<div class="card">
  <div class="card-body">
    <div class="mb-0">
      <div class="mb-2">
        <div class="row modal-content border border-dark ml-0 mb-4 p-0">
          <div class="col col-md-12">
            <div class="d-md-flex justify-content-between">
              <div class="col col-md-6 m-0 p-1">
                <div class="card-body rounded-top row pl-0">
                  <div class="col-2">
                    <img
                      src="../../../assets/images/store.png"
                      class="img-fluid"
                      alt="image"
                    />
                  </div>
                  <div class="col-10 p-2">
                    <div class="d-flex">
                      <p class="">#{{ data.workspace_code }}</p>
                      <h2 class="ml-4 fs-5 font-weight-bold">
                        {{ data.workspace_name | translate }}
                      </h2>
                      <p
                        class="ml-4"
                        [ngClass]="{
                          'text-danger':
                            data.device_subscription_status === 'Inactive',
                          'text-success':
                            data.device_subscription_status === 'Active'
                        }"
                      >
                        {{ data.device_subscription_status }}
                      </p>
                    </div>
                    <div class="d-flex">
                      <p class="">
                        Ngày kích hoạt:
                        {{ data.activation_date | date : "dd/MM/yyyy" }}
                      </p>
                      <p class="ml-4">Thành viên: {{ countMember || 1 }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <button
                  class="btn btn-sm btn-danger"
                  (click)="onUpdate(data, handleOrder)"
                >
                  Thao tác đơn hàng
                </button>
              </div>
            </div>
            <hr />
            <div>
              <h2>Thông tin gói dịch vụ & loa</h2>
              <div class="d-md-flex">
                <div class="col col-md-6 m-0 p-1">
                  <div class="card-body rounded-top row">
                    <div class="col-10 p-2">
                      <div class="d-flex">
                        <h2 class="fs-5 font-weight-bold">
                          Loại sản phẩm: {{ data.device_name | translate }}
                        </h2>
                      </div>
                      <div class="d-flex">
                        <p class="">Số lượng: {{ data.quantity || "1" }}</p>
                        <p class="ml-4">
                          Mã giới thiệu: {{ data.referrer || "Không có" }}
                        </p>
                      </div>
                      <div class="d-flex">
                        <p class="">
                          Gói dịch vụ: {{ data.original_duration }} tháng
                        </p>
                        <p class="ml-4">Lợi ích: {{ data.benefit }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="">
                          Ngày kích hoạt: {{ data.activation_date }}
                        </p>
                        <p class="ml-4">
                          Ngày hết hạn: {{ data.expiration_date }}
                        </p>
                      </div>
                      <div *ngIf="mb_reference_number" class="">
                        <div>Mã giao dịch: {{ mb_reference_number }}</div>

                        <button
                          [cdkCopyToClipboard]="mb_reference_number"
                          class="btn btn-sm btn-primary"
                        >
                          Sao chép mã
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col col-md-6 p-3 border-left my-2">
                  <div class="container">
                    <div class="g-3 row row-cols-1 row-cols-md-2">
                      <div class="col">
                        <div class="card shadow-sm border border-warning">
                          <div class="mt-2 mb-2">
                            <p class="text-center font-weight-bold">Giá gốc</p>
                            <p
                              class="text-center text-danger font-weight-bold m-0"
                            >
                              {{ data.original_price | number : "1.0-0" }}
                              <sup><ins>đ</ins></sup>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="card shadow-sm border border-warning">
                          <div class="mt-2 mb-2">
                            <p class="text-center font-weight-bold">
                              Giá sau giảm
                            </p>
                            <p
                              class="text-center text-success font-weight-bold m-0"
                            >
                              {{ data.discounted_price | number : "1.0-0" }}
                              <sup><ins>đ</ins></sup>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div>
              <h2>Thông tin giao hàng</h2>
              <button
                class="btn btn-outline-primary ml-2 mb-2 btn-sm"
                (click)="onDetailHistory(data, detailOrder)"
              >
                Chi tiết giao hàng
              </button>
              <div class="d-md-flex">
                <div class="col col-md-6 m-0 p-1">
                  <div class="card-body rounded-top row">
                    <div class="col-10 p-2">
                      <div class="d-flex">
                        <p class="font-weight-bold">Trạng thái đơn hàng:</p>
                        <p class="ml-2">{{ data.status }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="font-weight-bold">Địa chỉ giao hàng:</p>
                        <p
                          *ngIf="data.delivery_method == 'shipper'"
                          class="ml-2"
                        >
                          {{ data.address }}
                        </p>
                        <p
                          *ngIf="data.delivery_method == 'direct'"
                          class="ml-2"
                        >
                          {{ data.terminal_address }}
                        </p>
                      </div>
                      <div class="d-flex">
                        <p class="font-weight-bold">Người nhận:</p>
                        <p
                          *ngIf="data.delivery_method == 'shipper'"
                          class="ml-2"
                        >
                          {{ data.customer_name }}
                        </p>
                        <p
                          *ngIf="data.delivery_method == 'direct'"
                          class="ml-2"
                        >
                          {{ data.full_name }}
                        </p>
                      </div>
                      <div class="d-flex">
                        <p class="font-weight-bold">Số điện thoại:</p>
                        <p
                          *ngIf="data.delivery_method == 'shipper'"
                          class="ml-2"
                        >
                          {{ data.phone }}
                        </p>
                        <p
                          *ngIf="data.delivery_method == 'direct'"
                          class="ml-2"
                        >
                          {{ data.user_phone }}
                        </p>
                      </div>
                      <div
                        class="d-flex"
                        *ngIf="data.delivery_method == 'shipper'"
                      >
                        <p class="font-weight-bold">Mã đơn hàng:</p>
                        <p class="ml-2">
                          {{ data.order_code ? data.order_code : "Chưa có" }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col col-md-6 p-3 border-left my-2">
                  <div class="container">
                    <div class="g-3 row row-cols-1 row-cols-md-2">
                      <div class="col">
                        <div class="card shadow-sm border border-warning">
                          <div class="mt-2 mb-2">
                            <p class="text-center font-weight-bold">
                              Đơn vị giao hàng
                            </p>
                            <p class="text-center font-weight-bold m-0">
                              {{ data.shipping_unit }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="card shadow-sm border border-warning">
                          <div class="mt-2 mb-2">
                            <p class="text-center font-weight-bold">
                              Thời gian giao hàng dự kiến
                            </p>
                            <p class="text-center m-0">
                              {{ data.expected_delivery_time || "Chưa có" }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <!-- <div
            class="d-flex justify-content-end mb-2"
            *ngIf="role == 'admin' || role == 'delivery'"
          >
            <button
              class="btn btn-outline-success"
              (click)="onChange(data, pairDevice)"
            >
              Liên kết thiết bị
            </button>
          </div> -->
          <div class="col col-md-12 bg-viettel border rounded-top">
            <span class="text-white" style="font-size: 20px"
              >Danh sách thiết bị trong đơn hàng</span
            >
          </div>
          <div class="table-responsive">
            <table
              id="basic-datatable"
              class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
            >
              <thead>
                <tr class="text-center bg-table">
                  <th>{{ "#" | translate }}</th>
                  <th>{{ "Mã thiết bị" | translate }}</th>
                  <th>{{ "Model" | translate }}</th>
                  <th>{{ "Trạng thái" | translate }}</th>
                  <th>{{ "Ngày kích hoạt" | translate }}</th>
                  <th>{{ "Ngày hết hạn" | translate }}</th>
                  <th>{{ "Quản lý" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="text-center"
                  *ngFor="let data2 of listDataQR; let i = index"
                >
                  <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>

                  <td>{{ data2.serial_number }}</td>
                  <td>{{ data2.model }}</td>
                  <td
                    [ngClass]="{
                      'text-danger': data2.status === 'Inactive',
                      'text-success': data2.status === 'Active'
                    }"
                  >
                    {{ data2.status }}
                  </td>
                  <td>{{ data2.activation_date | date : "dd/MM/yyyy" }}</td>
                  <td>{{ data2.expiration_date | date : "dd/MM/yyyy" }}</td>
                  <td>
                    <div class="d-flex justify-content-around">
                      <a
                        (click)="onEdit(data2, contentQR)"
                        class="font-size-18 text-success"
                        ngbTooltip="{{ 'Hiển thi QR' | translate }}"
                        placement="left"
                      >
                        <i class="mdi mdi-qrcode-scan"></i>
                      </a>
                      <!-- <a
                        (click)="onChange(data2, contentLink)"
                        class="font-size-18 text-primary"
                        ngbTooltip="{{ 'Đổi thiết bị' | translate }}"
                        placement="left"
                      >
                        <i class="mdi mdi-swap-horizontal"></i>
                      </a> -->
                
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="">
          <div class="col col-md-12 bg-viettel border rounded-top">
            <span class="text-white" style="font-size: 20px"
              >Lịch sử thao tác</span
            >
          </div>
          <div class="table-responsive">
            <table
              id="basic-datatable"
              class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
            >
              <thead>
                <tr class="text-center bg-table">
                  <th>{{ "#" | translate }}</th>
                  <th>{{ "Người tác động" | translate }}</th>
                  <th>{{ "Ghi chú" | translate }}</th>
                  <th>{{ "Thao tác" | translate }}</th>
                  <th>{{ "Thời gian" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="text-center"
                  *ngFor="let data2 of listDataLog; let i = index"
                >
                  <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>
                  <td>{{ data2.full_name }}</td>
                  <td>{{ data2.note }}</td>
                  <td>{{ data2.action }}</td>
                  <td>{{ data2.datetime }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #contentLink role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ "Thay đổi thiết bị" | translate }}
    </h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="deviceLink()" [formGroup]="formData">
        <div class="row">
          <!-- Thiết bị hiện tại -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thiết bị" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>

          <!-- Thiết bị mới -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thiết bị mới" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="listDeviceLink"
                bindLabel="serial_number"
                bindValue="serial_number"
                formControlName="serial_number_new"
                (search)="onSearchChange($event)"
                placeholder="{{ 'Chọn thiết bị mới' | translate }}"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number_new.errors
                }"
              >
              </ng-select>
            </div>
          </div>

          <!-- Lý do thay đổi -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Lý do thay đổi" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="reasonOptions"
                bindLabel="label"
                bindValue="value"
                formControlName="reason"
                placeholder="{{ 'Chọn lý do' | translate }}"
                [ngClass]="{
                  'is-invalid': submitted && form.reason.errors
                }"
              >
              </ng-select>
            </div>
          </div>

          <!-- Ghi chú -->
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label">{{
              "Ghi chú" | translate
            }}</label>
            <div class="col-md-10">
              <textarea
                class="form-control"
                rows="3"
                formControlName="note"
                placeholder="{{ 'Nhập ghi chú (nếu có)' | translate }}"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
            [disabled]="
            !formData.get('serial_number')?.value ||
            !formData.get('serial_number_new')?.value ||
            !formData.get('reason')?.value 
          "          
          >
            {{ "Lưu" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentCancel role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Hủy đơn hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form #deleteForm="ngForm" (ngSubmit)="onDelete()" novalidate>
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">
              {{ "Lý do hủy" | translate }}
            </label>
            <div class="col-md-10">
              <input
                placeholder="Nhập lý do hủy"
                type="text"
                class="form-control"
                name="reasonDelete"
                [(ngModel)]="reasonDelete"
                required
                #reasonInput="ngModel"
                [ngClass]="{ 'is-invalid': submitted && reasonInput.invalid }"
              />
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-danger btn-lg"
            style="width: 150px"
            [disabled]="!reasonInput.valid"
          >
            {{ "Hủy đơn" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #updateOrderCode role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật mã đơn hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="updateCodeShip()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Mã đơn mới" | translate
            }}</label>
            <div class="col-12">
              <input
                type="text"
                class="form-control"
                formControlName="orderCode"
                [ngClass]="{ 'is-invalid': submitted && form.phone.errors }"
                [(ngModel)]="orderCode"
              />
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            [disabled]="!orderCode"
            type="submit"
            class="btn btn-primary btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentQR role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Hiển thị QR</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Serial" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <div class="col-md-12 d-block justify-content-center">
              <div class="d-flex justify-content-center">
                <div
                  class="borderQR d-flex flex-column align-items-center"
                  *ngIf="flagDownQr"
                  #qrContainer
                >
                  <div class="qr-with-text canvas-container">
                    <qr-code
                      class="custom-qr-code"
                      [value]="qrCodeValue"
                      [size]="400"
                      [errorCorrectionLevel]="'M'"
                    >
                    </qr-code>
                    <div class="text-center user-info" *ngIf="flagDownQr">
                      <h3 class="">
                        {{ data.terminal_bank_acc_name }}
                      </h3>
                      <h3 class="">
                        {{ data.terminal_bank_acc }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center mt-3">
                <div class="col-12 col-md-3 p-0">
                  <button class="btn-viettel col" (click)="downloadQRCode()">
                    <span class="m-auto">Tải xuống mã QR</span>
                  </button>
                  <button class="btn-viettel col mt-2" (click)="printQRCode()">
                    In QR Code
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <!-- <button
              type="submit"
              class="btn btn-success btn-lg"
              style="width: 150px;"
            >
              {{'Lưu' | translate}}
            </button> -->
          <!-- <button type="button" class="btn btn-secondary mb-2 btn-sm" style="width: 150px"
                          (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                      <button type="button" class="btn btn-primary mb-2 btn-sm ml-3" style="width: 150px"
                          (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #updatecontent role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật cuộc gọi</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="updateOrder()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Hành động" | translate
            }}</label>
            <div class="col-12">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="typeUpdate"
                [ngClass]="{
                  'is-invalid': submitted && form.typeUpdate.errors
                }"
              >
                <option value="{{ item.value }}" *ngFor="let item of typePhone">
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-5 col-form-label required_label">{{
              "Ghi chú" | translate
            }}</label>
            <div class="col-md-12">
              <textarea
                placeholder="Nhập ghi chú"
                class="form-control"
                formControlName="note"
                [ngClass]="{ 'is-invalid': submitted && form.note.errors }"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-primary btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<ng-template #updateDoneOrder role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật "Đã giao hàng"</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="updateDone()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Trạng thái đơn" | translate
            }}</label>
            <div class="col-12">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="typeUpdate"
                [ngClass]="{
                  'is-invalid': submitted && form.typeUpdate.errors
                }"
              >
                <option value="{{ item.value }}" *ngFor="let item of typeShip">
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Đơn vị giao" | translate
            }}</label>
            <div class="col-12">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="shipNote"
                [ngClass]="{ 'is-invalid': submitted && form.shipNote.errors }"
              >
                <option value="{{ item.value }}" *ngFor="let item of typeUnit">
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
          <div
            class="form-group row col-md-12"
            *ngIf="formData.value.shipNote !== 'other'; else orther"
          >
            <label class="col-md-5 col-form-label required_label">{{
              "Mã đơn mới" | translate
            }}</label>
            <div class="col-md-12">
              <textarea
                placeholder="Nhập mã đơn hàng"
                class="form-control"
                formControlName="orderCode"
                [ngClass]="{ 'is-invalid': submitted && form.orderCode.errors }"
                rows="3"
              ></textarea>
            </div>
          </div>
          <ng-template #orther>
            <div class="form-group row col-md-12">
              <label class="col-md-5 col-form-label required_label">{{
                "Ghi chú" | translate
              }}</label>
              <div class="col-md-12">
                <textarea
                  placeholder="Nhập ghi chú"
                  class="form-control"
                  formControlName="orderCode"
                  [ngClass]="{
                    'is-invalid': submitted && form.orderCode.errors
                  }"
                  rows="3"
                ></textarea>
              </div>
            </div>
          </ng-template>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            [disabled]="
              !formData.value.orderCode ||
              !formData.value.shipNote ||
              !formData.value.typeUpdate
            "
            type="submit"
            class="btn btn-primary btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #detailOrder role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Chi tiết vận chuyển đơn hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="table-responsive">
    <table
      id="basic-datatable"
      class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
    >
      <thead>
        <tr class="text-center bg-table">
          <th>{{ "#" | translate }}</th>
          <!-- <th>{{'Mã đơn' | translate}}</th> -->
          <th>{{ "Địa điểm" | translate }}</th>
          <th>{{ "Trạng thái" | translate }}</th>
          <th>{{ "Thời gian" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="text-center"
          *ngFor="let data2 of dataHistory; let i = index"
        >
          <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>
          <!-- <td>{{data2.order_code}}</td> -->
          <td>
            {{ data2.ware_house ? data2.ware_house : data2.localion_currently }}
          </td>
          <td>{{ data2.status ? data2.status : data2.status_name }}</td>
          <td>
            {{ data2.created_at ? data2.created_at : data2.order_statusdate }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
<ng-template #pairDevice role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Liên kết thiết bị</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="pairDevices()" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-5 col-form-label required_label">{{
              "Mã thiết bị" | translate
            }}</label>
            <div class="col-12">
              <ng-select
                [items]="listDeviceLink"
                bindLabel="serial_number"
                bindValue="serial_number"
                formControlName="serial_number"
                [searchable]="true"
                (search)="onSearchChange($event)"
                placeholder="{{ 'Chọn thiết bị' | translate }}"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              >
              </ng-select>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-primary btn-lg"
            style="width: 150px"
          >
            {{ "Cập nhật" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #handleOrder role="document" let-modal="close">
  <div class="modal-body">
    <p class="fw-bold mb-3">Chọn thao tác</p>
    <ul class="list-group">
      <!-- Delivery role -->
      <li
        *ngIf="role == 'delivery'"
        class="list-group-item list-group-item-action"
        (click)="onUpdate(data, updatecontent)"
      >
        📞 Cập nhật cuộc gọi
      </li>

      <li
        
        class="list-group-item list-group-item-action"
        (click)="onChange(data, updateOrderCode)"
      >
        🆔 Cập nhật mã đơn hàng
      </li>

      <li
        *ngIf="data.status_eng == 'complete' && role == 'delivery'"
        class="list-group-item list-group-item-action text-danger"
        (click)="onChange(data, updateDoneOrder)"
      >
        ✅ Cập nhật "Đã giao hàng"
      </li>

      <!-- Customer service / Operation / Admin -->
      <li
        *ngIf="
          role == 'customer service' || role == 'operation' || role == 'admin'
        "
        class="list-group-item list-group-item-action text-danger"
        (click)="onChangeTime(data)"
      >
        ⏳ Thêm 1 tháng sử dụng
      </li>

      <li
        *ngIf="
          role == 'customer service' || role == 'operation' || role == 'admin'
        "
        class="list-group-item list-group-item-action"
        (click)="onChange(data, updateOrderCode)"
      >
        🆔 Cập nhật mã đơn hàng
      </li>

      <!-- Nếu muốn bật lại hủy đơn hàng -->
      <!--
      <li *ngIf="!data.oc_id && (role == 'customer service' || role == 'admin')" 
          class="list-group-item list-group-item-action text-danger"
          (click)="onCancelOrder(data, contentCancel)">
        ❌ Hủy đơn hàng
      </li>
      -->
    </ul>
  </div>
</ng-template>


